(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var titleWrapper = document.querySelector(
      '.title-wrapper-with-link.title-wrapper--self-padded-tablet-down.title-wrapper--no-top-margin'
    );

    var viewAllDiv = document.querySelector(
      '.blog__view-all.center.small-hide.medium-hide.scroll-trigger.animate--slide-in'
    );

    if (titleWrapper && viewAllDiv) {
      var h2 = titleWrapper.querySelector('h2');

      if (h2) {
        h2.insertAdjacentElement('afterend', viewAllDiv);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('#featureSplide', {
      type: 'loop',
      perMove: 1,
      autoplay: true,
      perPage: 4,
      gap: '20px',
      arrows: false,
      pagination: false,
      breakpoints: {
        1440: { perPage: 3 },
        1023: { perPage: 2 },
        767: { perPage: 1 },
      },
    }).mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  var titleWrapper = document.querySelector('.title-wrapper-with-link.title-wrapper--self-padded-tablet-down.title-wrapper--no-top-margin');

  var viewAllDiv = document.querySelector('.blog__view-all.center.small-hide.medium-hide.scroll-trigger.animate--slide-in');

  if (titleWrapper && viewAllDiv) {
    var h2 = titleWrapper.querySelector('h2');

    if (h2) {
      h2.insertAdjacentElement('afterend', viewAllDiv);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  // JS for adding class in body
  document.addEventListener('DOMContentLoaded', function () {
    var bodyEl = document.querySelector('body');
    if (bodyEl && !bodyEl.classList.contains('cf-jb-article')) {
      bodyEl.classList.add('cf-jb-article');
    }
  });

  // JS for category function
  document.addEventListener('DOMContentLoaded', function () {
    var categoriesSection = document.querySelector('.cf-dp-categories-section');
    var articleContent = document.querySelector('.article-template__content');

    if (!categoriesSection || !articleContent) return;

    var lastParagraph = articleContent.querySelector('p:last-of-type');

    if (lastParagraph && categoriesSection.nextElementSibling !== lastParagraph) {
      lastParagraph.parentNode.insertBefore(categoriesSection, lastParagraph);
    }
  });

  // JS for instagram section
  $('.recent-post').after($('.instagram-blog-section'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const target = document.getElementById("variant-selects-template--26663164019063__main");
  
  if (target) {
    const newDiv = document.createElement("div");
    newDiv.classList.add("product-detail-wrapped-div");

    target.parentNode.insertBefore(newDiv, target.nextSibling);

    let nextEl = newDiv.nextElementSibling;
    for (let i = 0; i < 2 && nextEl; i++) {
      const temp = nextEl.nextElementSibling;
      if (nextEl.tagName === "DIV") {
        newDiv.appendChild(nextEl);
      }
      nextEl = temp;
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
